/// <amd-module name="Wit/Common/Utilities/Array" />

export function subtract<T>(arrayA: T[], arrayB: T[], comparer?: { (a: T, b: T): number }): T[] {
    var value: any;
    var result: any[];

    if (!arrayB || arrayB.length === 0) {
        return arrayA;
    }

    result = [];

    for (var i = 0, l = arrayA.length; i < l; i++) {
        value = arrayA[i];
        if (!contains(arrayB, value, comparer)) {
            result[result.length] = value;
        }
    }

    return result;
}

export function contains<T>(array: T[], value: T, comparer?: { (a: any, b: any): number }): boolean {
    if (typeof value === "undefined") {
        return false;
    }

    comparer = comparer || defaultComparer;

    for (var i = 0, l = array.length; i < l; i++) {
        if (typeof array[i] !== "undefined" && comparer(array[i], value) === 0) {
            return true;
        }
    }

    return false;
}

export function defaultComparer<T>(a: T, b: T): number {
    //weak equality should be enough for default comparer
    /*jslint eqeqeq:false */
    if (a == b) {
        return 0;
    } else if (a > b) {
        return 1;
    } else {
        return -1;
    }
    /*jslint eqeqeq:true */
}

/**
 * Sorts and removes duplicate elements
 *
 * @param array array to sort 
 * @param comparer comparer that will be used for sorting
 * @return sorted array without duplicate elements
 */
export function uniqueSort<T>(array: T[], comparer?: { (a: T, b: T): number }): T[] {
    comparer = comparer || defaultComparer;
    array.sort(comparer);

    for (var i = 1, l = array.length; i < l; i++) {
        if (comparer(array[i], array[i - 1]) === 0) {
            array.splice(i--, 1);
            l--;
        }
    }

    return array;
}

export function unique<T>(array: T[], comparer?: (a: T, b: T) => number): T[] {
    const result = array.slice(0);
    uniqueSort(result, comparer);

    return result;
}
